// src/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2023 Crisis24</p>
    </footer>
  );
};

export default Footer;
